import { BaseCollectionItem } from './BaseCollectionItem';

export class CollectionSubscriptionItem extends BaseCollectionItem {
  override canBeDuplicated(): boolean {
    return false;
  }
}
